/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventQuestionPublicRead } from './EventQuestionPublicRead';
import {
    EventQuestionPublicReadFromJSON,
    EventQuestionPublicReadFromJSONTyped,
    EventQuestionPublicReadToJSON,
    EventQuestionPublicReadToJSONTyped,
} from './EventQuestionPublicRead';
import type { EventQuestionOwnRead } from './EventQuestionOwnRead';
import {
    EventQuestionOwnReadFromJSON,
    EventQuestionOwnReadFromJSONTyped,
    EventQuestionOwnReadToJSON,
    EventQuestionOwnReadToJSONTyped,
} from './EventQuestionOwnRead';
import type { EventQuestionRead } from './EventQuestionRead';
import {
    EventQuestionReadFromJSON,
    EventQuestionReadFromJSONTyped,
    EventQuestionReadToJSON,
    EventQuestionReadToJSONTyped,
} from './EventQuestionRead';

/**
 * The questions of an event as the caller may see them.
 * 
 * `items` (every question) only for the event's administrators, null for everyone else;
 * `own` the caller's own questions; `published` the public list.
 * @export
 * @interface EventQuestionsRead
 */
export interface EventQuestionsRead {
    /**
     * 
     * @type {Array<EventQuestionRead>}
     * @memberof EventQuestionsRead
     */
    items?: Array<EventQuestionRead> | null;
    /**
     * 
     * @type {Array<EventQuestionOwnRead>}
     * @memberof EventQuestionsRead
     */
    own: Array<EventQuestionOwnRead>;
    /**
     * 
     * @type {Array<EventQuestionPublicRead>}
     * @memberof EventQuestionsRead
     */
    published: Array<EventQuestionPublicRead>;
}

/**
 * Check if a given object implements the EventQuestionsRead interface.
 */
export function instanceOfEventQuestionsRead(value: object): value is EventQuestionsRead {
    if (!('own' in value) || value['own'] === undefined) return false;
    if (!('published' in value) || value['published'] === undefined) return false;
    return true;
}

export function EventQuestionsReadFromJSON(json: any): EventQuestionsRead {
    return EventQuestionsReadFromJSONTyped(json, false);
}

export function EventQuestionsReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventQuestionsRead {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(EventQuestionReadFromJSON)),
        'own': ((json['own'] as Array<any>).map(EventQuestionOwnReadFromJSON)),
        'published': ((json['published'] as Array<any>).map(EventQuestionPublicReadFromJSON)),
    };
}

export function EventQuestionsReadToJSON(json: any): EventQuestionsRead {
    return EventQuestionsReadToJSONTyped(json, false);
}

export function EventQuestionsReadToJSONTyped(value?: EventQuestionsRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(EventQuestionReadToJSON)),
        'own': ((value['own'] as Array<any>).map(EventQuestionOwnReadToJSON)),
        'published': ((value['published'] as Array<any>).map(EventQuestionPublicReadToJSON)),
    };
}

